export default "__VITE_ASSET__CCMN28$K__"